module.exports = __webpack_public_path__ + "static/media/bg-home-top-left.9ed4b49e.png";